import { useState, useEffect } from "react";

import "./index.css";
import "./header.css";
import App from "./App";
import { BrowserRouter, Link } from "react-router-dom";
  
const Header = () => {
  return (  
   
  <header>
  <div className="headerName">
    <Link to="/">
    <h1>bugs_love</h1>
    </Link>
  </div>

  <div className="headerMenu">
    
    <Link to="/">
      Home
      </Link>
      <Link to ="/about">
        About
        </Link>
        <Link to="/vbr">
          VBR
          </Link>
          <Link to="/discography">
            Discography
            
            </Link>
             <Link to="/contact">
            Contact
            </Link>
         
  </div>
    
</header>
);
}

export default Header;